import Sentry from 'src/lib/sentry'
import { CedarProvider } from '@cedarjs/web'
import possibleTypes from 'src/graphql/possibleTypes'
import { GraphQLClientConfigProp, RedwoodApolloProvider } from '@cedarjs/web/apollo'
import { LocalizationProvider } from '@mui/x-date-pickers-pro'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { StyledEngineProvider } from '@mui/material/styles'

import "shepherd.js/dist/css/shepherd.css";
import { ShepherdJourneyProvider } from 'react-shepherd';

import FatalErrorPage from 'src/pages/FatalErrorPage'
import Routes from 'src/Routes'

import 'react-big-calendar/lib/css/react-big-calendar.css';

import { ApolloLink } from "@apollo/client";
import { ErrorLink } from "@apollo/client/link/error";

import './scaffold.css'
import { AuthProvider, useAuth } from './auth'

import './index.css'
import ThemeProviderLisaqua from './lib/theme'
import i18n from './i18n'
import { toast } from "@cedarjs/web/toast"
import { useUserPreferencesStore } from "./lib/store"
import { useMemo } from "react"

// import "./lib/wdyr"


//https://github.com/vitejs/vite/discussions/15897
//https://stackoverflow.com/a/78454579/1437016
//https://vite.dev/guide/build#load-error-handling
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  window.location.reload();
})

const App = () => {
  //Unzoom windows browsers that have a root em too large, and all the site gets too wide
  React.useEffect(() => {
    if (navigator.platform.indexOf('Win') > -1) {
      document.documentElement.classList.add('windows-zoomfix');
    }
  }, []);
  process.env.MATOMO_URL &&
    React.useEffect(() => {
      //@ts-expect-error _mtm doesn'exists
      var _mtm = (window._mtm = window._mtm || [])
      _mtm.push({ 'mtm.startTime': new Date().getTime(), event: 'mtm.Start' })

      var d = document,
        g = d.createElement('script'),
        s = d.getElementsByTagName('script')[0]
      g.async = true
      g.src = process.env.MATOMO_URL
      s.parentNode.insertBefore(g, s)
    })

  const positiveMode = useUserPreferencesStore(state => state.positiveMode)
  const graphQLClientConfig: GraphQLClientConfigProp = useMemo(()=> ({
    cacheConfig: {
      possibleTypes: possibleTypes.possibleTypes,
      ...(positiveMode ? {
        typePolicies: {
          Review: {
            fields: {
              description: { read: (value?: string) => value?.replaceAll('mort', 'rest') },
            }
          },
          Event: {
            fields: {
              description: { read: (value?: string) => value?.replaceAll(/mort/gi, 'rest') },
            }
          },
          EventType: {
            fields: {
              name: { read: (value?: string) => value?.replaceAll('Mortalité', 'Restes') },
            }
          },
          EventCriticality: {
            fields: {
              name: { read: (value?: string) => value?.replaceAll(/critique|majeur|mineur/gi, 'information') },
              color: { read: (value?: string) => value?.replace(/(#.{2})/, '#22') + 'AA' } //Remove the red part, and add transparency (#RRGGBB -> #22GGBBAA)
            }
          },
        },
      } : {}),
    },
    //Translate the error returned by the server if they match a code PXXXX under errorCodes.server
    //See /api/src/lib/extensions.ts
    //https://www.apollographql.com/docs/react/data/error-handling
    link: (redwoodApolloLinks) => {
      const errorLink = new ErrorLink((props) => {
        process.env.NODE_ENV != "production" && props.graphQLErrors?.forEach((error) => { toast.error(error.message) })
        props.response?.errors?.forEach((error) => {
          //@ts-expect-error we know it's readonly, but override it anyway on purpose
          error.message = i18n.t(`errorCodes.server.${error.message}`, { defaultValue: error.message, modelName: error.extensions?.modelName, foreignModelName: error.extensions?.foreignModelName })
        });
      })
      return ApolloLink.from([errorLink, ...redwoodApolloLinks.map(({ link }) => link)])
    }
  }), [positiveMode])
  return (
    <Sentry.ErrorBoundary fallback={FatalErrorPage}>
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        adapterLocale={i18n.language}
      >
        <CedarProvider titleTemplate="%PageTitle | %AppTitle">
          <AuthProvider>
            <RedwoodApolloProvider useAuth={useAuth} graphQLClientConfig={graphQLClientConfig}>
              <ThemeProviderLisaqua>
                <StyledEngineProvider injectFirst>
                  <ShepherdJourneyProvider>
                    <Routes />
                  </ShepherdJourneyProvider>
                </StyledEngineProvider>
              </ThemeProviderLisaqua>
            </RedwoodApolloProvider>
          </AuthProvider>
        </CedarProvider>
      </LocalizationProvider>
    </Sentry.ErrorBoundary>
  )
}
export default App
